import React, { memo } from 'react';
import moment from 'moment-timezone';

import { Typography } from '@material-ui/core';

import FormDialog from '../ResourceManagement/StepEditor/FormDialog';

import { useStyles } from './styles';

export interface IReportDetailsModal {
  data: any;
  closeModal: () => void;
}

const ReportDetailsModal = ({ data = {}, closeModal }: IReportDetailsModal) => {
  const classes = useStyles();

  return (
    <FormDialog
      open={true}
      title={`Emergency Report`}
      handleClose={closeModal}
      styleClasses={{ paper: classes.modalWrapper, root: classes.modalRoot }}
      titleClass={classes.reportModalTitle}
      hideSubmitButton={true}
      hasChanges={false}
      showHasChanges={false}
      confirmLabel={''}
      isLoading={false}
      handleDiscard={() => null}
      handleSubmit={() => null}
    >
      <Typography className={`${classes.cardFont} ${classes.cardFontAccent}`}>From:</Typography>
      <Typography className={classes.cardFont}>
        Worker Name: <span className={`${classes.cardFontAccent}`}>{data.workerName}</span>
      </Typography>
      <Typography className={classes.cardFont}>
        Employer: <span className={`${classes.cardFontAccent}`}>{data.workerCompanyName}</span>
      </Typography>
      <Typography className={classes.cardFont}>
        Project: <span className={`${classes.cardFontAccent}`}>{data.projectName}</span>
      </Typography>
      <Typography className={classes.cardFont}>
        Date & Time:{' '}
        <span className={`${classes.cardFontAccent}`}>
          {moment
            .utc(data.createdAt)
            .tz(data?.projectTimeZone?.code || moment.tz.guess())
            .format('MMMM DD, YYYY, hh:mm A')}
        </span>
      </Typography>
      <Typography className={`${classes.cardFont} ${classes.cardFontAccent} ${classes.messageText}`}>Message:</Typography>
      <span className={`${classes.cardFont}`}>{data.messageText}</span>
    </FormDialog>
  );
};

export default memo(ReportDetailsModal);
